import { v4 as uuidv4 } from "uuid";
export class AssetDetailViewModel {
    constructor() {
        this.id = uuidv4();
        this.assetTypeId = "";
        this.assetType = "";
        this.assetCode = "";
        this.assetCategory = "";
        this.name = "";
        this.assetStatus = "";
        this.vendorName = "";
        this.invoiceNumber = "";
        this.serialNumber = "";
        this.make = "";
        this.modelNumber = "";
        this.dateOfPurchaseAsString = "";
        this.price = "";
        this.employeeName = "";
        this.teamName = "";
        this.warrantyStartDateAsString = "";
        this.warrantyPeriod = "";
        this.warrantyEndDateAsString = "";
        this.scrappedOnAsString = "";
        this.disposedOnAsString = "";
        this.isRepair = true;
        this.assetLocationId = "";
        this.assetLocationName = "";
    }
}
export default class AssetDetailView extends AssetDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
